module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controlSet"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "set-option"
  }, [_c('div', [_c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.loadControlConf(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.loading ? '正在加载' : '刷新数据'))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "css-margin-top"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": "{min-height:'300px'}"
    }
  }, [(_vm.loading) ? _c('loading') : [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("参数列表")]), _vm._v(" "), _c('span', {
    staticClass: "time-show"
  }, [_vm._v(_vm._s(_vm.timeShow))]), _vm._v(" "), _c('span')]), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.tableData.slice(0, Math.round(_vm.tableData.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [_c('p', [_vm._v(_vm._s(scope.row.data))])])]
        }
      }])
    })], 1)], _vm._v(" "), [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.tableData.slice(Math.round(_vm.tableData.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [_c('p', [_vm._v(_vm._s(scope.row.data))])])]
        }
      }])
    })], 1)]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "mobile-val-table",
      attrs: {
        "data": _vm.tableData
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('p', {
            staticStyle: {
              "font-size": "14px"
            }
          }, [_vm._v(_vm._s(scope.row.name))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [_c('p', [_vm._v(_vm._s(scope.row.data))])])]
        }
      }])
    })], 1)]
  ], 2) : _vm._e()]], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32300071"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/allocateWater/autoVal.vue
// module id = 908
// module chunks = 1